/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Header from "../template/_common/header";
import SidebarComponent from "../template/admin/sidebarComponent";
import StoresTable from "../template/admin/storesTable";
import SidebarArrow from "../template/_common/sidebarArrow";
import { globalAlert, globalLoader } from "../actions/commonActions";
import AddStoreModal from "../template/admin/addStoreModal";
import { MAP_SHOW_LIST } from "../actionTypes/types";
import { Select, FormControl, MenuItem, InputLabel } from "@mui/material";
import {
  getProductListApi,
  viewStoreApi,
  addStoreApi,
  updateStoreApi,
  deleteProductApi,
  addStockApi,
  getStoreDownloadList,
  toggleProductApi,
  adminZonerListApi,
  addProductApi
} from "./_actions";
import ViewQrModal from "../template/admin/viewQrModal";
import ConfirmationModal from "../template/_common/confirmModal";
import PaginationOwn from "../template/_common/ownPagination";
import { compareValues, exportData, logOut } from "../_shared/commonFunction";
import { Helmet } from "react-helmet";
import InputComponent from "../template/_common/inputComponent";
import ManageStockModal from "../template/admin/manageStockModal";
import arraySort from 'array-sort';
import ProductCatalougeTable from "../template/admin/productTable";
import AddProductModal from "../template/admin/addProductModel";

const ManageProductCatalouge = (props) => {
  const { t } = useTranslation();
  const [navbarToggle, setNavbarToggle] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [currentData, setCurrentData] = useState(null);
  const [openAddStoreModal, setopenAddStoreModal] = useState(false);
  const [openStockModal, setOpenStockModal] = useState(false);
  const [editDataIs, setEditDataIs] = useState(false);
  const [openViewStore, setOpenViewStore] = useState(false);
  const [currentViewData, setCurrentViewData] = useState(null);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [confirmaModalOpen, setConfirmaModalOpen] = useState(false);
  const [pageSize, setPageSize] = useState(25);
  const [searchVal, setSearchVal] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [currentDataList, setCurrentDataList] = useState([]);
  const [sortObj, setSortObj] = useState({});
  const [currentDataSorted, setCurrentDataSorted] = useState([]);
  const [totalCount, setTotalCount] = useState(false);
  const [allowView, setAllowView] = useState(false);
  const [deleteInfo, setDeleteInfo] = useState(null);
  const [toggleInfo, setToggleInfo] = useState(null);
  const [searchValue, setSearchValue] = useState('');
  const [zoneList, setZoneList] = useState(null);
  const [zoneFilterList, setZoneFilterList] = useState(null);
  const [zoneValue, setZoneValue] = useState('All');

  const [hiddenOnMap, setHiddenOnMap] = useState('all')

  const handleSidebar = (data) => {
    setNavbarToggle(data);
  };

  useEffect(() => {
    callBasicApi(true); // eslint-disable-next-line
  }, []);

  useEffect(() => {
    callBasicApi();
  }, [zoneValue]);

  const callBasicApi = async (zoneApiCall = null) => {
    try {
      globalLoader(true);
      let res = await getProductListApi();
      if (res?.data?.status === 200) {
        setAllowView(true);
        setSearchVal('')
        setDataList(res?.data?.data?.list);
      } else {
        globalAlert("error", res?.data?.message);
      }
      globalLoader(false);
    } catch (error) {
      globalAlert("error", error?.response?.data?.message);

      if (error?.response?.data?.status === 401) {
        logOut(props?.history, "/admin/login");
      }
      globalLoader(false);
    }
  };

  const closeAddStoreModal = async (val = null) => {
    if (val) {
      globalLoader(true);
   
      if (editDataIs) {

        val.append("orgProductId", currentData?.orgProductId)
      }
   
      let res= await addProductApi(val);

      if (res?.data?.status === 200) {
        globalAlert("success", res?.data?.message);
        if (!editDataIs) {
          setSearchVal("");
        }
        
        setEditDataIs(false);
        setCurrentData(null);
        setopenAddStoreModal(false);
        callBasicApi();
      } else {
        globalAlert("error", res?.data?.message);
        globalLoader(false);
      }
    } else {
      setEditDataIs(false);
      setCurrentData(null);
      setopenAddStoreModal(false);
    }
  };

  const editData = (data) => {
    setEditDataIs(true);
    setCurrentData(data);
    setopenAddStoreModal(true);
  };

  const viewQrData = async (data) => {
    globalLoader(true);
    let res = await viewStoreApi(data);
    if (res?.data?.status === 200) {
      setCurrentViewData(res?.data?.data?.orgStore);
      setOpenViewStore(true);
    } else {
      globalAlert("error", res?.data?.message);
    }
    globalLoader(false);
  };

  const confirmModalFunc = async (val) => {
    if (val) {
      globalLoader(true);

      let res;

      if(toggleInfo){
       res = await toggleProductApi(currentUserId);
      }
      else{
       res= await deleteProductApi(currentUserId);
      }
      
      if (res?.data?.status === 200) {
        setEditDataIs(false);
        setCurrentData(null);
        setToggleInfo(null);
        setDeleteInfo(null)
        
        if (totalCount === 1) setSearchVal("");
        callBasicApi();
      } else {
        globalAlert("error", res?.data?.message);
        globalLoader(false);
      }
    }
    setConfirmaModalOpen(false);
    setDeleteInfo(null);
    setToggleInfo(null);
  };

  const closeStockModal = async (val = null) => {
    if (val) {
      try {
        globalLoader(true);
        let res = await addStockApi(currentViewData?.orgProductId, val);
        if (res?.data?.status === 200) {
          setEditDataIs(false);
          setCurrentViewData(null);
          
          callBasicApi();
        } else {
          globalAlert("error", res?.data?.message);
          globalLoader(false);
        }
      } catch { 
        globalLoader(false);
      }
    }
    setOpenStockModal(false);
  };

  const handleFilterChangeZone = (ev) => {
    if (ev?.target?.value) {
      setZoneValue(ev?.target?.value)
    }
  };


  const downloadFile =async ()=>{

    try{
      globalLoader(true);
      let res = await getStoreDownloadList();

      if (res?.status === 200) {    
        if(!res.data){
          globalAlert("error", t("common.noDataFound"));
        }   
        else{
          exportData(res.data,  `Store_${new Date().getTime()}.csv`, 'text/csv');
        }
      } else {
        globalAlert("error", res?.message);
      }
      globalLoader(false);
    }
    catch{
      globalAlert("error", t("common.somethingWentWrong"));
      globalLoader(false);
    }

  }

  const deleteData = (data) => {
   
    setCurrentUserId(data?.orgProductId);
    let obj = [`Product Name : ${data?.name}`, `Description : ${data?.description}`];
    setDeleteInfo(obj);
    setConfirmaModalOpen(true);
  };

  const toggleData = (data) => {
  
    setCurrentUserId(data?.orgProductId);
    let obj = [`Product Name : ${data?.name}`, `Description : ${data?.description}`];
    setToggleInfo(obj);
    setCurrentData(data)
    setConfirmaModalOpen(true);
  };

  const manageStockData = (data) => {
    setCurrentUserId(data?.orgProductId); // eslint-disable-next-line
    props?.history?.push({
      pathname: `/admin/manage-stores/${data?.orgProductId}`,
      state: { data },
    });
    // setOpenStockModal(true)
    // setCurrentViewData(data)
  };

  useEffect(() => {

    filteredDataFunc();

  }, [pageSize, currentPage, sortObj, currentDataSorted, dataList, hiddenOnMap, searchValue]);

  const filteredDataFunc = (dataArray = null, localPage = null) => {
    let arr = [...dataList];
    let filterArr = [];
    let filteredData = [];

    if (dataArray) {
      arr = [...dataArray]
    }
    else {
      arr = arraySort(arr, compareValues(sortObj?.sortVal), { reverse: sortObj?.sortType === 'desc' ? true : false });
    }
    if (searchValue.length > 0) {
      filterArr = arr.filter((data) => {
        let name = data?.name.toLowerCase();
        let val = searchValue.toLowerCase();

        if (name?.includes(val)) {
          return data;
        } else {
          return null;
        }
      });
    } else {
      filterArr = arr;
    }

    if (filterArr?.length > 0) {
      if (hiddenOnMap === 'yes') {
        filterArr = filterArr.filter(ele => ele?.hideOnMap)


      }
      else if (hiddenOnMap === 'no') {
        filterArr = filterArr.filter(ele => !ele?.hideOnMap)
      }
    }




    if (filterArr && filterArr.length > 0) {
      setTotalCount(filterArr.length);
      for (
        let i = (localPage || currentPage) * pageSize - pageSize;
        i < (localPage || currentPage) * pageSize && i < filterArr.length;
        i++
      ) {
        filteredData.push(filterArr[i]);
      }
    }

    setCurrentDataList(filteredData);
  };

  const changePageSizeFunc = async (val) => {
    
    setPageSize(val.target.value);
    setCurrentPage(1);
    setSortObj(null);
  };

  const searchFilter = (ev) => {
    ev.preventDefault();
    let arr = [...dataList];
    let filterArr = [];

    arr.forEach(
      (data) => {
        let name = data?.name.toLowerCase();
        let val = searchValue.toLowerCase();

        if (name.includes(val)) {

          filterArr.push(data)
        }

      }


    );

    setTotalCount(filterArr.length);
    
    setCurrentDataList(filterArr);
    filteredDataFunc(filterArr)
    setCurrentPage(1);
    setSortObj(null);
    
  };

  const goToPageFunc = (val, data) => {
    
    if (data === "prev" && currentPage > 1) {
      setCurrentPage(currentPage - 1);
    } else if (
      data === "next" &&
      currentPage < Math.ceil(dataList?.length / pageSize)
    ) {
      setCurrentPage(currentPage + 1);
    } else {
      setCurrentPage(val?.target?.value);
    }
  };

  const arraySorting = (val) => {
    let arr = [...dataList];
    let sortedArr;
    let sortType = "aesc";
    if (val === sortObj?.sortVal && sortObj?.sortType === "aesc") {
      sortType = "desc";
    }
    sortedArr = arraySort(arr, compareValues(val), { reverse: sortType === 'desc' ? true : false });
  
    setCurrentPage(1);
    setSortObj({
      sortVal: val,
      sortType: sortType,
    });
    filteredDataFunc(sortedArr, 1);
  };



  return (
    <>
      <Helmet>
        <title>{t("admin.pageTitle.productCatalogue")} - eC-Card</title>
        <meta name="viewport" content="width=1200, initial-scale=1" />
      </Helmet>
      {allowView && (
        <div className="admin-portal">
          <Header roleType="admin" />
          <div className={`${navbarToggle ? "active" : ""} wrapper`}>
            <SidebarComponent
              navbarToggle={navbarToggle}
             
              menu="manageVenue"
              subMenu='manage-product-catalouge'
            />
            <div className="main">
              <div className="main-wrapper">
                <div>
                  <p className="admin-banner">{t("admin.products.title")}</p>
                </div>
                <SidebarArrow handleSidebarToggle={handleSidebar} />
                <div className="container-fluid">
  <div className="row form-report my-2">
    <div className="col-12">
      <div className="row admin-controls">
        {/* Search */}
        <form
          onSubmit={searchFilter}
          className="col-12 col-lg-6 admin-search"
        >
          <div className="search-wrapper">
            <InputComponent
              placeholder="Search..."
              label="search"
              type="text"
              name="search"
              theme="admin"
              value={searchVal}
              handleCallback={(val) => {
                setSearchVal(val);
              }}
            />
          </div>

          <button type="submit" className="btn secondary-btn">
            {t("common.go")}
          </button>
        </form>

        {/* Add Button */}
        <div className="col-12 col-lg-6 d-flex justify-content-start justify-content-lg-end align-items-center mt-3 mt-lg-0">
          <button
            onClick={() => setopenAddStoreModal(true)}
            className="btn secondary-btn modal-btn"
          >
            <i className="fas fa-plus me-2"></i>
            {t("admin.products.addButton")}
          </button>
        </div>

        {/* Pagination */}
        {dataList?.length > 0 && (
          <div
            className="col-12 pt-3 mt-3"
            style={{ borderTop: "2px solid #ebeef1" }}
          >
            <PaginationOwn
              pageSize={pageSize}
              changePageSize={changePageSizeFunc}
              goToPage={goToPageFunc}
              totalCount={totalCount}
              currentPage={currentPage}
              applicationType={
                currentDataList?.length > 1 ? "users" : "user"
              }
            />
          </div>
        )}
      </div>
    </div>
  </div>
</div>
                {currentDataList?.length > 0 ? (
                  <ProductCatalougeTable
                    dataList={currentDataList}
                    arraySorting={arraySorting}
                    basicApiCall={callBasicApi}
                    sortObj={sortObj}
                    viewQrData={viewQrData}
                    editData={editData}
                    deleteData={deleteData}
                    manageStockData={manageStockData}
                    toggleData={toggleData}
                  />
                ) : (
                  <div className="px-3 pt-3">
                    <div className="no-data-available">{t("common.noDataAvailable")}</div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {openAddStoreModal && (
        <AddProductModal
          open={openAddStoreModal}
          closeModal={closeAddStoreModal}
          data={currentData}
          edit={editDataIs}
          zoneList={zoneList}
        />
      )}

     
      {openStockModal && (
        <ManageStockModal
          open={openStockModal}
          closeModal={closeStockModal}
          data={currentViewData}
        />
      )}
      {confirmaModalOpen && (
        <ConfirmationModal
          open={confirmaModalOpen}
          deleteInfo={toggleInfo || deleteInfo}
          description={toggleInfo? (currentData?.isActive ? t("admin.products.confirmDeactivateProduct") : t("admin.products.confirmActivateProduct")) : t("admin.products.confirmDeleteProduct")}
          onCloseModal={confirmModalFunc}
        />
      )}
    </>
  );
};

export default ManageProductCatalouge;
